module.exports = __webpack_public_path__ + "static/pancakes-4c8b314887cbef854b0e435e22df7499.gif";